import { IntentProps } from '../../../core/slots/Intent/Intent.js';
import {
  BaseToolbarProps,
  InternalChartToolbarConfig,
} from '../../core/types/toolbar.js';

/** Props for the ChartToolbar implementation in SingleValue
 * @public
 */
export interface SingleValueToolbarSlotProps extends BaseToolbarProps {
  /** Decides if the toolbar is draggable
   * @deprecated - Will be removed in next breaking version. Toolbar is always draggable.
   * @defaultValue false
   */
  draggable?: boolean;
}

/** Internal props for the ChartToolbar implementation in SingleValue
 * @internal
 */
export interface SingleValueToolbarInternalProps
  extends InternalChartToolbarConfig {
  /** Intents to show in the toolbar */
  intents?: Array<IntentProps>;
  /** Decides if the toolbar is hidden */
  hidden: boolean;
}

export const defaultToolbarInternalConfig: SingleValueToolbarInternalProps = {
  hidden: false,
  intents: [],
  placement: 'top-right',
  collapsed: false,
  draggable: false,
};
